/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:bb0bf329-f2c7-4b2b-9bf4-7fdda795ad92",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_2J0ylGZl9",
    "aws_user_pools_web_client_id": "20as906ljv76ob0qkstoinunr5",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://aonm5yl5zjfg3ixh2yabrsunw4.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-3fbukbwndbd2ze5irqeujnk4dy",
    "aws_user_files_s3_bucket": "codemochicourses61452-master",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
